export default __webpack_public_path__ + "static/media/Caja_ancha_eneable.835cbeb9.svg";